/**
 * Colour hero banner — consumer for Discover the Pen colour.
 * Listens to kb:pen-colour-change from Sticky colour selector.
 *
 * See docs/shared-pen-colour.md
 */
(() => {
  const EVENT_NAME = 'kb:pen-colour-change';

  if (!customElements.get('colour-hero-banner')) {
    class ColourHeroBanner extends HTMLElement {
      constructor() {
        super();

        this.handleColourChange = this.handleColourChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }

      connectedCallback() {
        this.panels = Array.from(
          this.querySelectorAll('[data-colour-hero-banner-panel]')
        );

        if (!this.panels.length) {
          return;
        }

        const current = window.KBPenColour?.get();

        if (current?.colorHandle) {
          this.activateByHandle(current.colorHandle);
        }

        document.addEventListener(EVENT_NAME, this.handleColourChange);

        if (window.Shopify?.designMode) {
          document.addEventListener(
            'shopify:block:select',
            this.handleBlockSelect
          );
        }
      }

      disconnectedCallback() {
        document.removeEventListener(EVENT_NAME, this.handleColourChange);

        if (window.Shopify?.designMode) {
          document.removeEventListener(
            'shopify:block:select',
            this.handleBlockSelect
          );
        }
      }

      handleColourChange(event) {
        const colorHandle = event.detail?.colorHandle;

        if (!colorHandle) {
          return;
        }

        this.activateByHandle(colorHandle);
      }

      handleBlockSelect(event) {
        const panel = event.target.closest('[data-colour-hero-banner-panel]');

        if (!panel || !this.contains(panel)) {
          return;
        }

        this.activateByHandle(panel.dataset.colorHandle);
      }

      activateByHandle(colorHandle) {
        if (!colorHandle) {
          return;
        }

        const activePanel = this.panels.find(
          (panel) => panel.dataset.colorHandle === colorHandle
        );

        if (!activePanel) {
          return;
        }

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.colorHandle === colorHandle;

          panel.classList.toggle('colour-hero-banner__panel--active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dataset.selectedColor = activePanel.dataset.colorName || '';
        this.dataset.selectedColorHandle = colorHandle;
        this.dataset.selectedBlockId = activePanel.dataset.blockId || '';
      }
    }

    customElements.define('colour-hero-banner', ColourHeroBanner);
  }
})();
